import React, { useEffect, useState } from 'react'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { ptBR } from "date-fns/locale";
import { Box, InputLabel } from '@material-ui/core';

interface DatePickerProps {
    label: string;
    name: string;
    value?: any;
    maxDate?: any;
    error: string;
    onChange: (e: any) => void;
    onBlur?: (e: any) => void;

}

export default function DatePicker(props: DatePickerProps) {

    const [dateValue, setDateValue] = useState(null);

    const { name, label, error = null, maxDate = null} = props

    const convertToDefEventPara = (name: string, value: any) => ({
        target: {
            name, value
        }
    })

    useEffect(() => {
        if(!props.value || props.value.toString() === ""){
            setDateValue(null)
        }else{
            setDateValue(props.value)
        }
    }, [props.value]);

    const handleDateChange = (date: any) => {
        props.onChange(date)
        setDateValue(date.target.value)
    };

    const handleDateBlur = (date: any) => {
        if (date.target.value === "") {
            date.target.value = null
            props.onChange(date)
        } else {
            var parts = date.target.value.split('/');
            
            if(parseInt(parts[1]) <= 12 && parseInt(parts[0]) <= 31){
                var dateConverted = new Date(parts[2], parts[1] - 1, parts[0]); 
                date.target.value = dateConverted;
                props.onChange(convertToDefEventPara(name, dateConverted))
                setDateValue(date.target.value);
            }
        }
    };

    return (
        <React.Fragment>
            <Box mt={1}>
                <InputLabel {...(error && { error: true })} style={{"color": (!error ? '#000' : '') }} >{label}</InputLabel>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                    <KeyboardDatePicker disableToolbar inputVariant="standard"
                        format="dd/MM/yyyy"
                        maxDateMessage="Data maior que a data limite"
                        minDateMessage="Data menor que a data limite"
                        maxDate={maxDate == null ? undefined : maxDate}
                        clearable
                        fullWidth
                        name={name}
                        invalidDateMessage="Data em formato inválido."
                        placeholder="dd/MM/yyyy"
                        cancelLabel="Cancelar"
                        value={dateValue}
                        {...(error && { error: true, helperText: error })}
                        onBlur={handleDateBlur}
                        onChange={(date) => handleDateChange(convertToDefEventPara(name, date))}
                    />
                </MuiPickersUtilsProvider>
            </Box>
        </React.Fragment>
    )
}
